import Button from '@mui/material/Button'
import { pathOr } from 'ramda'
import React from 'react'

import { FormSpecs } from '@/app/types'

import { UploadConfigsWithOptionalKey } from '../../types'

type Props = {
  configs: Configs | null
  specs: FormSpecs
  statuses: boolean[]
  backHandler: () => void
  submitHandler: (config: Configs) => void
}

type Configs = UploadConfigsWithOptionalKey

const ContactsUploadReviewActions: React.FC<Props> = ({ configs, specs, statuses, backHandler, submitHandler }) => {
  if (!configs) {
    return null
  }

  return (
    <>
      <Button variant="outlined" onClick={backHandler}>
        Back
      </Button>
      <Button
        id="contacts-upload-review-button"
        variant="contained"
        color="primary"
        onClick={() => submitHandler(filterUnchecked(configs, specs, statuses))}
      >
        Confirm
      </Button>
    </>
  )
}

export const filterUnchecked = (config: Configs, specs: FormSpecs, statuses: boolean[]): Configs =>
  Object.keys(specs).reduce<Configs>((acc, field) => {
    const index = pathOr(false, ['fieldsToColumns', field], acc)

    if (index && !statuses[index]) {
      return {
        ...acc,
        fieldsToColumns: {
          ...acc.fieldsToColumns,
          [field]: '',
        },
      }
    }
    const customField = field.replace('customFields.', '')
    const customIndex = pathOr(false, ['customFieldsToColumns', customField], acc)
    if (customIndex && !statuses[customIndex]) {
      return {
        ...acc,
        customFieldsToColumns: {
          ...acc.customFieldsToColumns,
          [customField]: '',
        },
      }
    }

    return acc
  }, config)

export default ContactsUploadReviewActions
